import React, { useEffect } from 'react'
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import TutorFooter from '../TutorFooter/TutorFooter'
import { Link } from 'react-router-dom'
import {
    CircularProgressbar,
    buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

// Animation
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "../../../utils/AnimatedProgressProvider";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { getProfileData } from '../../../Redux/action/MasterAction';
import { useDispatch, useSelector } from 'react-redux';
import Beatloader from '../../../Common/BeatLoader';

const host = process.env.REACT_APP_API_SERVER
const TutorProfile = () => {
    const dispatch = useDispatch()
    const authToken = localStorage.getItem('tutor-token');

    const {
        ProfileDataListApiData,
        loadingProfileDataListApi,
        ProfileDataListApiError,
    } = useSelector(state => state?.MasterReducer);

    useEffect(() => {

        dispatch(getProfileData(authToken));

    }, []);

    return (
        <div className='tutor-profile'>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Profile
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                <div className="student-profile-sec px-3">
                                    <div className="row mb-5">


                                    </div>
                                </div>
                                <ul className="nav nav-tabs tutor-profile-tabs" id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link active"
                                            id="personal-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#personal"
                                            type="button"
                                            role="tab"
                                            aria-controls="personal"
                                            aria-selected="false"
                                        >
                                            <i className="fa-regular fa-user" /> Personal Information
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="bank-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#bank"
                                            type="button"
                                            role="tab"
                                            aria-controls="bank"
                                            aria-selected="true"
                                        >
                                            <i className="fa-solid fa-building-columns" /> Bank Details
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="price-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#price"
                                            type="button"
                                            role="tab"
                                            aria-controls="price"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-tag" /> Update Tutoring Price
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="tutor-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#tutor"
                                            type="button"
                                            role="tab"
                                            aria-controls="tutor"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-person-vcard-fill" /> Tutor Teaching List
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="nav-link"
                                            id="cip-tab"
                                            data-bs-toggle="tab"
                                            data-bs-target="#cip"
                                            type="button"
                                            role="tab"
                                            aria-controls="cip"
                                            aria-selected="false"
                                        >
                                            <i className="bi bi-person-fill-check" /> CIP Details
                                        </button>
                                    </li>
                                </ul>
                                <div
                                    className="tab-content"
                                    id="myTabContent"
                                    style={{ backgroundColor: "aliceblue" }}
                                >
                                    {/* Personal Information */}
                                    {loadingProfileDataListApi ?
                                        <Beatloader />
                                        :
                                        <div
                                            className="tab-pane tutor-profile-tab-pane fade show active p-3"
                                            id="personal"
                                            role="tabpanel"
                                            aria-labelledby="personal-tab"
                                        >
                                            <form>
                                                <div className="d-flex justify-content-between my-4">
                                                    <h5>Personal Information</h5>
                                                    <Link
                                                        to="/tutor/profile-settings-personal-info"
                                                        className="btn btn-primary edit-btn"
                                                    >
                                                        <i className="bi bi-pencil-square" />
                                                        &nbsp;Edit
                                                    </Link>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-12 mb-2 w-100 d-flex justify-content-center pt-5">
                                                        <div className="profile-top-sec w-50">
                                                            <div className="profile-top-img d-flex justify-content-center">
                                                                <OverlayTrigger

                                                                    placement='right'
                                                                    overlay={
                                                                        <Tooltip className='bg-light'>
                                                                            {ProfileDataListApiData?.profile_status_percentage}%
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <div className="img-sec position-relative">
                                                                        {/* Circular Progress Bar */}
                                                                        <AnimatedProgressProvider
                                                                            valueStart={0}
                                                                            valueEnd={ProfileDataListApiData?.profile_status_percentage}
                                                                            duration={1.4}
                                                                            easingFunction={easeQuadInOut}

                                                                        >
                                                                            {value => {
                                                                                const roundedValue = Math.round(value);
                                                                                return (
                                                                                    <CircularProgressbar
                                                                                        value={value}

                                                                                        /* This is important to include, because if you're fully managing the
                                                                                  animation yourself, you'll want to disable the CSS animation. */
                                                                                        styles={buildStyles({ pathTransition: "none" })}
                                                                                    />
                                                                                );
                                                                            }}
                                                                        </AnimatedProgressProvider>
                                                                        {/* Profile Image */}
                                                                        <img
                                                                            src={`${host}${ProfileDataListApiData?.data?.profile_img}`}

                                                                            onError={(e) => {
                                                                                e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                                            }}
                                                                            className="profile-img"
                                                                        />
                                                                    </div>
                                                                </OverlayTrigger>
                                                            </div>
                                                            <h4 className="text-center mt-3">{ProfileDataListApiData?.data?.name}</h4>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Full Name
                                                        </label>


                                                        <p className=" input-form bg-white">{ProfileDataListApiData?.data?.name}</p>

                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Phone Number
                                                        </label>
                                                        <p className=" input-form bg-white">
                                                            {ProfileDataListApiData?.data?.country_code} {ProfileDataListApiData?.data?.mobile}

                                                        </p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Email ID
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.email}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Date of Birth
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.dob}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Gender
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.gender}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Address Line-1
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.address_line_1}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Address Line-2
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.address_line_2}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Country
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.countries?.name}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            State
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.states?.name}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            City
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.cities?.name}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Zip code
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.zip_code}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Qualification
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.qualifications}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Specialization
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.specialization}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Experience in years
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.experience}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Tutoring location
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.tutoring_location}</p>
                                                    </div>
                                                    {/* <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Session Price One to One
                                                        </label>
                                                        <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_one_to_one}</p>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Session Price Group
                                                        </label>
                                                        <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_group}</p>
                                                    </div> */}
                                                    <div className="col-lg-6 col-md-6">
                                                        <label htmlFor="" className="label">
                                                            Instructor Language
                                                        </label>
                                                        <p className="input-form bg-white">{ProfileDataListApiData?.data?.tutordetails?.language}</p>
                                                    </div>
                                                    <div className="col-lg-12 col-md-12">
                                                        <label htmlFor="" className="label">
                                                            About the tutor
                                                        </label>

                                                        <textarea
                                                            className="input-form w-100 rounded"
                                                            readOnly
                                                            defaultValue={ProfileDataListApiData?.data?.tutordetails?.about_the_tutor}
                                                        />
                                                    </div>
                                                </div>
                                            </form>
                                        </div>}
                                    {/* Bank Details */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="bank"
                                        role="tabpanel"
                                        aria-labelledby="bank-tab"
                                    >
                                        <form>
                                            <div className="d-flex justify-content-between my-4">
                                                <h5>Bank Details</h5>
                                                <Link
                                                    to="/tutor/profile-settings-bank-details"
                                                    className="btn btn-primary edit-btn"
                                                >
                                                    <i className="bi bi-pencil-square" />
                                                    &nbsp;Edit
                                                </Link>
                                            </div>

                                            {(() => {
                                                const bank = ProfileDataListApiData?.data?.tutorbankdetails;
                                                const countryType = bank?.country_type;

                                                return (
                                                    <div className="row">

                                                        {/* Account Holder */}
                                                        <div className="col-lg-6 col-md-6">
                                                            <label className="label">Account Holder</label>
                                                            <p className="input-form bg-white">{bank?.account_holder}</p>
                                                        </div>

                                                        {/* Account Number */}
                                                        <div className="col-lg-6 col-md-6">
                                                            <label className="label">Account Number</label>
                                                            <p className="input-form bg-white">{bank?.account_number}</p>
                                                        </div>

                                                        {/* Bank Name */}
                                                        <div className="col-lg-6 col-md-6">
                                                            <label className="label">Bank Name</label>
                                                            <p className="input-form bg-white">{bank?.bank_name}</p>
                                                        </div>

                                                        {/* INDIA */}
                                                        {countryType === "india" && (
                                                            <>
                                                                <div className="col-lg-6 col-md-6">
                                                                    <label className="label">IFSC Code</label>
                                                                    <p className="input-form bg-white">{bank?.ifsc_code}</p>
                                                                </div>

                                                                <div className="col-lg-6 col-md-6">
                                                                    <label className="label">SWIFT / BIC Code</label>
                                                                    <p className="input-form bg-white">{bank?.swift_code}</p>
                                                                </div>
                                                            </>
                                                        )}

                                                        {/* US */}
                                                        {countryType === "us" && (
                                                            <div className="col-lg-6 col-md-6">
                                                                <label className="label">Routing Number (ACH / ABA)</label>
                                                                <p className="input-form bg-white">{bank?.routing_no}</p>
                                                            </div>
                                                        )}

                                                        {/* OTHER */}
                                                        {countryType === "other" && (
                                                            <>
                                                                <div className="col-lg-6 col-md-6">
                                                                    <label className="label">SWIFT / BIC Code</label>
                                                                    <p className="input-form bg-white">{bank?.swift_code}</p>
                                                                </div>

                                                                <div className="col-lg-6 col-md-6">
                                                                    <label className="label">Wire Transfer Number</label>
                                                                    <p className="input-form bg-white">{bank?.wire_transfer_no}</p>
                                                                </div>
                                                            </>
                                                        )}

                                                        {/* BANK ADDRESS — LAST */}
                                                        <div className="col-lg-6 col-md-6">
                                                            <label className="label">Bank Address</label>
                                                            <p className="input-form bg-white">{bank?.bank_address}</p>
                                                        </div>

                                                    </div>
                                                );
                                            })()}
                                        </form>
                                    </div>

                                    {/* Updated Tutoring Price */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="price"
                                        role="tabpanel"
                                        aria-labelledby="price-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>Updated Tutoring Price</h5>
                                            <Link
                                                to="/tutor/profile-settings-updated-tutoring-price"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <label htmlFor="" className="label">
                                                    Session Price One To One<span className='text-danger'>*</span>
                                                </label>
                                                <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_one_to_one}</p>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <label htmlFor="" className="label">
                                                    Session Price Group<span className='text-danger'>*</span>
                                                </label>
                                                <p className="input-form bg-white">${ProfileDataListApiData?.data?.tutordetails?.per_session_price_group}</p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Tutor Teaching List */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="tutor"
                                        role="tabpanel"
                                        aria-labelledby="tutor-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>Tutor Teaching List</h5>
                                            <Link
                                                to="/tutor/profile-settings-tutor-teaching-list"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            {ProfileDataListApiData?.data?.tutorteachingdetails?.map((data) => (
                                                <div className="col-lg-6 col-md-6 mb-4">
                                                    <div className="tutor-teaching-list">
                                                        <div className="row">
                                                            <div className="col-lg-3 col-md-3 d-flex align-item-center flex-wrap">
                                                                <div
                                                                    className="initial-circle"
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        backgroundColor: '#f0f0f0',
                                                                        color: '#333',
                                                                        fontSize: '24px',
                                                                        fontWeight: 'bold',
                                                                        borderRadius: '50%',
                                                                        width: '80px',
                                                                        height: '80px',
                                                                        textTransform: 'uppercase',
                                                                    }}
                                                                >
                                                                    {data?.sub_category?.name?.charAt(0) || '-'}
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-6 col-md-5 pt-3">
                                                                <h6 className=" tutor-teaching-list-h6">{data?.category?.other_name ? data?.category?.other_name : data?.category?.name}</h6>
                                                                <p className=" tutor-teaching-list-eco mt-1">{data?.sub_category?.other_name ? data?.sub_category?.other_name : data?.sub_category?.name}</p>
                                                                <p className=" tutor-teaching-list-group ">{data?.teaching_type_id ? 'Group' : 'One To One'}</p>
                                                            </div>
                                                            <div className="col-lg-3 col-md-4">
                                                                <p className=" tutor-teaching-list-approve">{data?.status}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-6 mb-3">
                                                <input
                                                    type="submit"
                                                    defaultValue="Submit"
                                                    id="submit-btn-four"
                                                    className="btn btn-primary input-form-submit submit-btn w-100"
                                                    style={{ display: "none" }}
                                                />
                                            </div>
                                            <div className="col-lg-3 col-md-6 mb-3">
                                                <button
                                                    type="button"
                                                    id="add-btn"
                                                    className="btn btn-primary w-100"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal"
                                                    style={{ display: "none" }}
                                                >
                                                    <i className="fa-solid fa-plus" />
                                                    &nbsp;Add
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Cip Details */}
                                    <div
                                        className="tab-pane tutor-profile-tab-pane fade p-3"
                                        id="cip"
                                        role="tabpanel"
                                        aria-labelledby="cip-tab"
                                    >
                                        <div className="d-flex justify-content-between my-4">
                                            <h5>CIP (Customer Identification Program)</h5>
                                            <Link
                                                to="/tutor/profile-settings-cip"
                                                className="btn btn-primary edit-btn"
                                            >
                                                <i className="bi bi-pencil-square" />
                                                &nbsp;Edit
                                            </Link>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload educational document image</h5>

                                                    <div className="image-preview" id="imagePreview">
                                                        <img
                                                            id="preview"
                                                            width={100}
                                                            src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.educational_degree}`}

                                                            onError={(e) => {
                                                                e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                            }}
                                                            alt="Image Preview"

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload certificate image</h5>

                                                    <div className="image-preview" id="imagePreview">
                                                        <img
                                                            id="preview"
                                                            width={100}
                                                            src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.certification}`}

                                                            onError={(e) => {
                                                                e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                            }}
                                                            alt="Image Preview"

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6 mb-4">
                                                <div className="cip-card rounded">
                                                    <h5>Upload any valid Govt ID proof</h5>

                                                    <div className="image-preview" id="imagePreview">
                                                        <img
                                                            id="preview"
                                                            width={100}
                                                            src={`${host}/${ProfileDataListApiData?.data?.tutorkycdetails?.kyc_document}`}

                                                            onError={(e) => {
                                                                e.target.src = '/assets/img/user/broken-image.png'; // Fallback image
                                                            }}
                                                            alt="Image Preview"

                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-12">
                                                <input
                                                    type="submit"
                                                    defaultValue="Submit"
                                                    className="btn btn-primary input-form-submit submit-btn w-100"
                                                    id="submit-btn-five"
                                                    style={{ display: "none" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorProfile